<template>
  <div class="home">    
    <div>
      
      <div class="navbar-custom navbar-splash">            
        <the-header />
      </div>
      <section class="splash">
        <h1 class="sr-only">Find your destination</h1>
        <picture>
          <source
            srcset="
              @/assets/images/splash/kids-forest-fade-sm-1x.jpg,
              @/assets/images/splash/kids-forest-fade-sm-2x.jpg 2x
            "
            media="(max-width:640px)"
          />
          <source
            srcset="
              @/assets/images/splash/kids-forest-md-1x.jpg,
              @/assets/images/splash/kids-forest-md-2x.jpg 2x
            "
            media="(max-width:1024px)"
          />
          <source
            srcset="
              @/assets/images/splash/kids-forest-lg-1x.jpg,
              @/assets/images/splash/kids-forest-lg-2x.jpg 2x
            "
          />
          <img
            src="@/assets/images/splash/kids-forest-lg-1x.jpg"
            alt="A group of kids hiking on a trail."
            class="splash-image"
          />
        </picture>
        <div class="splash-overlay" >
          <div class="container-fluid" >
            <div class="search-box" :class="searchResultsClass" style="padding-top:50px">
              <div class="search-input" >
                <label for="park_query" class="sr-only"
                  >Search for a destination</label
                >
                <input
                  type="text"
                  id="park_query"
                  name="park_query"
                  class="form-control"
                  placeholder="Find your destination..."
                  v-model="search"
                  v-on:focus="searchFocus"
                  v-on:blur="searchBlur"
                  autocomplete="off"
                  
                />
                <button type="button" class="btn-submit">
                  <font-awesome-icon icon="search" />
                  <span class="sr-only">Search</span>
                </button>
              </div>

              <div class="search-results" style="margin-top:50px">
                <ul id="search-park-list" class="list-links">
                  <li v-if="!sites || sites.length == 0" class="text-success">
                    <div class="list-loading">
                      <font-awesome-icon
                        icon="spinner"
                        class="fa fa-fw fa-pulse fa-2x"
                        style="text-color:black"
                      />One moment...
                    </div>
                  </li>
                  <div v-if="sites">
                    <li v-for="site in searchResults" :key="site.id">
                      <router-link
                        v-if="!site.isState"
                        :to="{ name: 'siteInput', params: { siteId: site.id } }"
                        >{{ site.name }}</router-link
                      >
                      <a v-else :href="stateUrl + '/Park/' + site.id">
                        {{ site.name }}
                      </a>
                    </li>
                  </div>
                </ul>
              </div>
              <div class="search-text">
                <p class="text-sm hl-behind hidden-xs">
                  <strong>Purchase your pass for:</strong>&nbsp;
                  <router-link
                    :to="{ name: 'siteInput', params: { siteId: 74271 } }"
                    >Acadia National Park</router-link
                  >,
                  <a :href="stateUrl + '/Park/eureka'"
                    >Eureka Springs Tram Tours</a
                  >,
                  <a href="/r1s/site/70202">Lake Havasu Shoreline Sites BLM</a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div class="info page-row page-row-dark section-info">
        <div class="container-fluid">
          <div class="col-sm-10 col-sm-offset-1">
            <p>
              <strong>YourPassNow</strong> allows visitors to federal and state
              public lands to purchase their entrance passes and recreation
              permits online, and Arrive Ready!
            </p>
          </div>
        </div>
      </div>

      <destinations-map></destinations-map>

      <section id="about" class="page-row">
        <div class="social layout-table layout-table--centered">
          <h2>Connect with us:</h2>
          <div>
            <a
              href="http://facebook.com/yourpassnow"
              class="btn btn-facebook btn-lg"
            >
              <font-awesome-icon :icon="['fab', 'facebook']" />Facebook
            </a>
          </div>
        </div>
        <hr class="hr-half" />
        <div class="partners layout-table layout-table--centered">
          <div>
            <picture>
              <source
                srcset="
                  @/assets/images/partners/Logo-NPS.png,
                  @/assets/images/partners/Logo-NPS@2x.png 2x
                "
              />
              <img
                src="@/assets/images/partners/Logo-NPS.png"
                alt="U.S. National Park Service"
              />
            </picture>
          </div>
          <div>
            <picture>
              <source
                srcset="
                  @/assets/images/partners/Logo-USFS.png,
                  @/assets/images/partners/Logo-USFS@2x.png 2x
                "
              />
              <img
                src="@/assets/images/partners/Logo-USFS.png"
                alt="U.S. Forest Service"
              />
            </picture>
          </div>
          <div>
            <picture>
              <source
                srcset="
                  @/assets/images/partners/Logo-BLM.png,
                  @/assets/images/partners/Logo-BLM@2x.png 2x
                "
              />
              <img
                src="@/assets/images/partners/Logo-BLM.png"
                alt="USDOT Bureau of Land Management"
              />
            </picture>
          </div>
          <div class="hr-vertical"></div>
          <div>
            <picture>
              <source
                srcset="
                  @/assets/images/partners/Logo-INA.png,
                  @/assets/images/partners/Logo-INA@2x.png 2x
                "
              />
              <img
                src="@/assets/images/partners/Logo-INA.png"
                alt="Information Network of Arkansas"
              />
            </picture>
          </div>
        </div>
        <p class="text-center">Authorized Pass Vendors</p>
      </section>
    </div>
    <TheFooter />
  </div>
</template>
<script>
// @ is an alias to /src
import TheFooter from "@/components/Shared/TheFooter.vue";
import TheHeader from "@/components/Shared/TheHeader.vue";
//import SiteService from "@/services/SiteService.js";
import DestinationsMap from "@/components/Home/DestinationsMap.vue";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faCoffee,
  faSearch,
  faBinoculars,
  faTimes,
  faSpinner
} from "@fortawesome/free-solid-svg-icons";

import { faFacebook } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(faCoffee);
library.add(faSearch);
library.add(faBinoculars);
library.add(faFacebook);
library.add(faTimes);
library.add(faSpinner);

export default {
  name: "home",
  components: {
    TheFooter,
    TheHeader,
    DestinationsMap,
    FontAwesomeIcon
  },
  data() {
    return {
      searchResultsClass: "",
      search: "",
      sites: []
    };
  },
  methods: {
    searchFocus: function() {
      this.searchResultsClass = "search-open";
    },
    searchBlur: function() {},
    getAllSites() {    
      this.sites.push(...this.getStateSites());
      this.sites.sort((a, b) => (a.name > b.name ? 1 : -1));
      //let service = new SiteService();
      // service.getAllSites().then(data => {
      //   this.sites = data.facilities;
      //   this.sites.push(...this.getStateSites());
      //   this.sites.sort((a, b) => (a.name > b.name ? 1 : -1));
      // });
    },
    getStateSites() {
      let states = [];
      let eureka = {
        name: "Eureka Springs Tram Tours",
        id: "eureka",
        isState: true
      };
      let nj = {
        name: "New Jersey State Parks",
        id: "nj",
        isState: true
      };

      let horse = {
        name: "Kentucky Horse Park",
        id: "horse",
        isState: true
      };
      let trolley = {
        name: "Eureka Springs Trolley System",
        id: "trolley",
        isState: true
      };
      let kilgore = {
        name: "Rocks State Park - Falling Branch/Kilgore Falls Area",
        id: "kilgore",
        isState: true
      };
      let wi = {
        name: "Wisconsin State Park System",
        id: "wi",
        isState: true
      };
      let mayo = {
        name: "Mayo Beach Park - Anne Arundel County",
        id: "mayo",
        isState: true
      };
      let thomaspt = {
        name: "Thomas Point Park - Anne Arundel County",
        id: "thomaspt",
        isState: true
      };
      let ftsmallwood = {
        name: "Fort Smallwood Park - Anne Arundel County",
        id: "ftsmallwood",
        isState: true
      };
      let qw = {
        name: "Quiet Waters Park - Anne Arundel County",
        id: "qw",
        isState: true
      };
      let downs = {
        name: "Downs Park - Anne Arundel County",
        id: "downs",
        isState: true
      };
      let kinder = {
        name: "Kinder Farm Park - Anne Arundel County",
        id: "kinder",
        isState: true
      };
      let beverly = {
        name: "Beverly Triton Park - Anne Arundel County",
        id: "beverly",
        isState: true
      };
      states.push(eureka);
      states.push(trolley);
      states.push(nj);
      states.push(horse);
      states.push(kilgore);
      states.push(wi);
      states.push(mayo);
      states.push(thomaspt);
      states.push(qw);
      states.push(ftsmallwood);
      states.push(downs);
      states.push(kinder);
      states.push(beverly);
      

      return states;
    }
  },
  computed: {
    searchResults: function() {
      if (this.search === "" || !this.sites) {
        return this.sites;
      }
      return this.sites.filter(site => {
        return site.name.toLowerCase().includes(this.search.toLowerCase());
      });
    },
    stateUrl() {
      return process.env.VUE_APP_STATE_URL;
    }
  },
  beforeCreate() {
    //Clear any save data
    this.$store.commit("cart/clearAllState");
    this.$store.commit("passInput/clearAllState");
  },
  beforeMount() {
    this.getAllSites();
  }
};
</script>
